// Preserve the in-progress Vollmacht UI while switching tabs in the same SPA session.
// Do not persist personal data to browser storage or carry it across a reload.
const flows = new Map();

export const getSigningFlow = (requestId) =>
  requestId ? flows.get(requestId) || {} : {};

export const rememberSigningFlow = (requestId, changes) => {
  if (requestId) {
    flows.set(requestId, { ...getSigningFlow(requestId), ...changes });
  }
};

export const forgetSigningFlow = (requestId) => {
  if (requestId) flows.delete(requestId);
};
